

angular
.module('inkfinder')
.factory('EmailConfirmation', function EmailConfirmation(
  $http,
  ENDPOINT
) {
  // Public functions
  EmailConfirmation.get = get;

  /**
   * @description Update the email_is_confirmed field by sending the
   * email_confirmation_token
   * @param {string} token The token to determine the collector to update
   * @return {object} Returns the collector
   */
  function get(token) {
    return $http.get(ENDPOINT.server +
    'collectors/api/v1.1/email/confirmation/?email_confirmation_token=' +
    token)
    .then(function(response) {
      return response.data;
    }, function(error) {
      return error;
    });
  }
  return EmailConfirmation;
});



// WEBPACK FOOTER //
// ./components/collector/email-confirmation/email-confirmation.service.js